module.exports = __webpack_public_path__ + "c3f0993aa06d6679f26e79536a8b16c3.pdf";